import React from 'react'
import { Link } from 'react-router-dom'
import MediaWithShimmer from '../components/MediaWithShimmer'
import ClickableVideo from '../components/ClickableVideo'
import ExpandableDescription from '../components/ExpandableDescription'
import { useLanguage } from '../contexts/LanguageContext'

const AlrichePresentation=()=>{
  const { language }=useLanguage()

  React.useLayoutEffect(() => {
    const scrollToTop = () => window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
    scrollToTop()
    const frame = window.requestAnimationFrame(scrollToTop)
    return () => window.cancelAnimationFrame(frame)
  }, [])

  return (
    <div className="min-h-screen bg-[#F9F8F4] overflow-x-hidden presentation-readable">
      <div style={{ height: '10rem' }} aria-hidden="true" />
      <section id="exclusive-collection" className="bg-[#F9F8F4]">
        {/* ── P1 COVER — full-bleed photo, gold signature, left text block ── */}
        <div className="relative w-full h-[72vh] min-h-[480px] md:h-[80vh] md:min-h-[540px] overflow-hidden bg-black">
          <MediaWithShimmer
            src="/pdf/aliens/cover.jpg"
            alt="ALIENS from The Planet MARS"
            eager={true}
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/65 via-black/25 to-transparent" />
          <div className="relative max-w-[1500px] mx-auto h-full px-6 md:px-12 lg:px-16 flex flex-col justify-center">
            <p className="text-[#CEA15F] font-bold tracking-[0.35em] text-sm md:text-base montserrat">ALRICHE</p>
            <div className="w-24 h-px bg-[#CEA15F] my-5" />
            <h2 className="text-white font-bold montserrat text-4xl md:text-5xl lg:text-6xl leading-[1.06]">
              «ALIENS&nbsp;&nbsp;from the<span className="hidden sm:inline">&nbsp;</span><br className="sm:hidden" />Planet&nbsp;&nbsp;MARS»
            </h2>
            <p className="text-[#CEA15F] font-bold montserrat tracking-[0.22em] text-xs md:text-sm mt-8 uppercase">
              {language === 'ru' ? 'Новая коллекция 2026' : 'New Collection 2026'}
            </p>
            <p className="text-white/90 montserrat font-light text-lg md:text-2xl mt-14 md:mt-20">
              {language === 'ru' ? 'Мода за пределами Вселенной' : 'Fashion Beyond the Universe'}
            </p>
            <p className="text-white/80 montserrat text-xs mt-10 md:mt-14">Angelina Alriche · Cannes, France</p>
          </div>
        </div>

{/* ── P3 THE CONCEPT — black page, photo LEFT / text RIGHT half ── */}
        <div className="grid md:grid-cols-2 bg-[#080707]">
          <div className="order-2 px-6 md:px-12 lg:px-16 py-14 md:py-20 flex flex-col justify-center">
            <p className="text-[#CEA15F] font-bold tracking-[0.3em] text-[11px] md:text-xs uppercase montserrat">
              {language === 'ru' ? 'Концепция' : 'The Concept'}
            </p>
            <h3 className="text-white font-bold montserrat text-3xl md:text-4xl leading-tight mt-4">
              {language === 'ru' ? 'КОСМИЧЕСКОЕ ВИДЕНИЕ' : 'A COSMIC VISION'}
            </h3>
            <p className="text-white/85 montserrat text-sm md:text-base leading-relaxed mt-6 max-w-lg">
              {language === 'ru'
                ? '«Инопланетяне с планеты МАРС» — это путешествие в будущее, где высокая мода встречается с космическим воображением и инновациями.'
                : '"ALIENS from The Planet MARS" is a journey into the future, where haute couture meets cosmic imagination and innovation.'}
            </p>
            <p className="text-white/80 montserrat text-xs md:text-sm leading-relaxed mt-6 max-w-lg">
              {language === 'ru'
                ? 'Больше, чем мода — визуальный язык трансформации, технологий и потусторонней красоты.'
                : 'More than fashion — a visual language of transformation, technology and otherworldly beauty.'}
            </p>
          </div>
          <div className="order-1">
            <MediaWithShimmer
              src="/pdf/aliens/concept.jpg"
              alt="Cosmic vision look"
              className="w-full h-[320px] md:h-[540px] lg:h-[620px] object-cover"
            />
          </div>
        </div>

        {/* ── P5 CRAFTSMANSHIP — ivory text panel LEFT / photo RIGHT half ── */}
        <div className="grid md:grid-cols-2 bg-[#EFE8DF]">
          <div className="order-2">
            <MediaWithShimmer
              src="/pdf/aliens/craft.jpg"
              alt="Craftsmanship backstage"
              className="w-full h-[320px] md:h-[540px] lg:h-[620px] object-cover"
            />
          </div>
          <div className="order-1 px-6 md:px-12 lg:px-16 py-14 md:py-20 flex flex-col justify-center">
            <p className="text-[#B08A45] font-bold tracking-[0.3em] text-[11px] md:text-xs uppercase montserrat">
              {language === 'ru' ? 'Мастерство' : 'Craftsmanship'}
            </p>
            <h3 className="text-gray-900 font-bold montserrat text-3xl md:text-4xl leading-tight mt-4">
              {language === 'ru' ? 'РАЗРАБОТАНО ANGELINA  ALRICHE' : 'DESIGNED BY ANGELINA  ALRICHE'}
            </h3>
            <p className="text-gray-800 montserrat text-sm md:text-base leading-relaxed mt-6 max-w-lg">
              {language === 'ru'
                ? 'Каждая деталь коллекции была лично разработана ANGELINA  ALRICHE с исключительной точностью и воплощена высококвалифицированными мастерами и портными Дома моды ALRICHE.'
                : 'Every detail of the collection was personally designed by ANGELINA  ALRICHE with exceptional precision and brought to life by the highly skilled artisans and master tailors of the ALRICHE Fashion House.'}
            </p>
            <p className="text-gray-600 montserrat text-xs md:text-sm leading-relaxed mt-6 max-w-lg">
              {language === 'ru'
                ? 'От скульптурных силуэтов до изысканных головных уборов — рука дизайнера видна в каждом образе.'
                : 'From sculptural silhouettes to intricate headpieces, the hand of the designer remains visible in every look.'}
            </p>
          </div>
        </div>

                {/* ── P8(2) BEHIND THE LOOK — black page, two runway portraits LEFT / serif text RIGHT ── */}
        <div className="grid md:grid-cols-2 bg-[#080707]">
          <div className="order-2 md:order-1 grid grid-cols-2">
            <MediaWithShimmer
              src="/pdf/aliens/crafted-1.jpg"
              alt="Crafted by hand — golden armor look"
              className="w-full h-[300px] md:h-[540px] lg:h-[620px] object-cover"
            />
            <MediaWithShimmer
              src="/pdf/aliens/crafted-2.jpg"
              alt="Crafted by hand — white couture look"
              className="w-full h-[300px] md:h-[540px] lg:h-[620px] object-cover"
            />
          </div>
          <div className="order-1 md:order-2 px-6 md:px-12 lg:px-16 py-14 md:py-20 flex flex-col justify-center">
            <p className="text-[#CEA15F] font-bold tracking-[0.3em] text-[11px] md:text-xs uppercase montserrat">
              {language === 'ru' ? 'За кадром' : 'Behind the Look'}
            </p>
            <h3 className="playfair font-bold text-white text-3xl md:text-4xl lg:text-5xl mt-4 leading-tight">
              {language === 'ru' ? 'СОЗДАНО ВРУЧНУЮ' : 'CRAFTED BY HAND'}
            </h3>
            <p className="text-white/85 montserrat text-sm md:text-[15px] leading-relaxed mt-7 max-w-lg">
              {language === 'ru'
                ? 'Каждый образ — это сотрудничество точного дизайнерского видения Анжелины Алричи и мастерских рук artesанов и портных ALRICHE.'
                : "Every look is a collaboration between Angelina Alriche's precise design vision and the expert hands of ALRICHE artisans and master tailors."}
            </p>
            <p className="text-white/80 montserrat text-sm md:text-[15px] leading-relaxed mt-5 max-w-lg">
              {language === 'ru'
                ? 'От скульптурных головных уборов и масок до кристаллов, закреплённых вручную, и изысканных металлических деталей — финальная отделка превращает каждый наряд в коллекционный предмет модного искусства.'
                : 'From sculptural headpieces and masks to hand-placed crystals and intricate metallic details, the finishing process transforms each garment into a collectible piece of fashion art.'}
            </p>
            <p className="text-[#CEA15F] font-bold montserrat text-[10px] md:text-xs tracking-[0.25em] uppercase mt-9">
              {language === 'ru' ? 'Точность • Мастерство • Инновации' : 'PRECISION • ARTISANSHIP • INNOVATION'}
            </p>
          </div>
        </div>

        {/* ── MASTERS AT WORK — black page, craft process photo+video grid ── */}
        <div className="bg-[#080707] px-6 md:px-12 lg:px-16 py-14 md:py-20">
          <p className="text-[#CEA15F] font-bold tracking-[0.3em] text-[11px] md:text-xs uppercase montserrat">
            {language === 'ru' ? 'Работа мастеров' : 'Masters at Work'}
          </p>
          <h3 className="playfair font-bold text-white text-3xl md:text-4xl lg:text-5xl mt-4 leading-tight">
            {language === 'ru' ? 'КАК МАСТЕРА ДЕЛАЛИ КОЛЛЕКЦИЮ' : 'HOW THE MASTERS CRAFTED THE COLLECTION'}
          </h3>
          <p className="text-white/80 montserrat text-xs md:text-sm leading-relaxed mt-5 max-w-2xl">
            {language === 'ru'
              ? 'Ручная работа мастеров ALRICHE: примерки, отделка и отливка масок под заказ — процесс создания коллекции ALIENS from The Planet MARS.'
              : 'The handwork of ALRICHE artisans: fittings, finishing and masks cast to order — the making of the ALIENS from The Planet MARS collection.'}
          </p>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4 mt-10">
            {[
              { type: 'photo', src: '/masters/WhatsApp%20Image%202026-08-30%20at%2016.31.56.jpeg' },
              { type: 'video', src: '/masters/WhatsApp%20Video%202026-08-30%20at%2016.30.33.mp4' },
              { type: 'photo', src: '/masters/WhatsApp%20Image%202026-08-30%20at%2016.32.13.jpeg' },
              { type: 'video', src: '/masters/WhatsApp%20Video%202026-08-30%20at%2016.31.33.mp4' },
              { type: 'photo', src: '/masters/WhatsApp%20Image%202026-08-30%20at%2016.32.13%20(1).jpeg' },
              { type: 'video', src: '/masters/WhatsApp%20Video%202026-08-30%20at%2016.32.13.mp4' }
            ].map((item, index) => (
              <div key={index} className="aspect-square overflow-hidden">
                {item.type === 'photo' ? (
                  <MediaWithShimmer
                    src={item.src}
                    alt={language === 'ru' ? `Работа мастеров ${index + 1}` : `Masters at work ${index + 1}`}
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <ClickableVideo src={item.src} className="w-full h-full object-cover" />
                )}
              </div>
            ))}
          </div>
          <p className="text-[#CEA15F] font-bold montserrat text-[10px] md:text-xs tracking-[0.25em] uppercase mt-8">
            {language === 'ru' ? 'Маски отливали под заказ • Masks cast to order' : 'MASKS CAST TO ORDER'}
          </p>
        </div>

        {/* ── LIFE BECOMES PART OF THE CREATION — complete photo + video presentation ── */}
        <div className="bg-[#F9F8F4] px-6 md:px-12 lg:px-16 py-14 md:py-20">
          <div className="max-w-5xl">
            <p className="text-[#CEA15F] font-bold tracking-[0.3em] text-[11px] md:text-xs uppercase montserrat">
              {language === 'ru' ? 'История создания' : 'The Story of Creation'}
            </p>
            <div className="w-24 h-px bg-[#CEA15F] my-7" />
            <h3 className="playfair text-gray-900 text-3xl md:text-4xl lg:text-5xl leading-[1.2]">
              {language === 'ru'
                ? 'Иногда дизайнер создаёт коллекцию в далеко не идеальных условиях. Иногда сама жизнь становится частью её создания.'
                : 'Sometimes a designer creates a collection under less-than-ideal conditions. Sometimes life itself becomes part of its creation.'}
            </h3>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-4 mt-12">
            {[
              { type: 'photo', src: '/creation/WhatsApp%20Image%202026-09-02%20at%2000.19.08.jpeg' },
              { type: 'photo', src: '/creation/WhatsApp%20Image%202026-09-02%20at%2000.19.10%20(1).jpeg' },
              { type: 'photo', src: '/creation/WhatsApp%20Image%202026-09-02%20at%2000.19.10%20(2).jpeg' },
              { type: 'photo', src: '/creation/WhatsApp%20Image%202026-09-02%20at%2000.19.10%20(3).jpeg' },
              { type: 'photo', src: '/creation/WhatsApp%20Image%202026-09-02%20at%2000.19.10.jpeg' },
              { type: 'photo', src: '/creation/WhatsApp%20Image%202026-09-02%20at%2000.19.11.jpeg' },
              { type: 'photo', src: '/creation/WhatsApp%20Image%202026-09-02%20at%2000.19.13%20(1).jpeg' },
              { type: 'photo', src: '/creation/WhatsApp%20Image%202026-09-02%20at%2000.19.13%20(2).jpeg' },
              { type: 'photo', src: '/creation/WhatsApp%20Image%202026-09-02%20at%2000.19.13.jpeg' },
              { type: 'photo', src: '/creation/WhatsApp%20Image%202026-09-02%20at%2000.19.14%20(1).jpeg' },
              { type: 'photo', src: '/creation/WhatsApp%20Image%202026-09-02%20at%2000.19.14.jpeg' },
              { type: 'video', src: '/creation/WhatsApp%20Video%202026-09-02%20at%2000.19.14.mp4' }
            ].map((item, index) => (
              <div key={item.src} className="aspect-[3/4] overflow-hidden bg-black">
                {item.type === 'photo' ? (
                  <MediaWithShimmer
                    src={item.src}
                    alt={language === 'ru' ? `Создание коллекции ALIENS from The Planet MARS ${index + 1}` : `Creating the ALIENS from The Planet MARS collection ${index + 1}`}
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <ClickableVideo src={item.src} className="w-full h-full object-cover" />
                )}
              </div>
            ))}
          </div>
        </div>

{/* ── P6 THE ACHIEVEMENT — black page, gold stats LEFT / photo RIGHT ── */}
        <div className="grid md:grid-cols-2 bg-[#080707]">
          <div className="px-6 md:px-12 lg:px-16 py-14 md:py-20 flex flex-col justify-center">
            <p className="text-[#CEA15F] font-bold tracking-[0.3em] text-[11px] md:text-xs uppercase montserrat">
              {language === 'ru' ? 'Достижение' : 'The Achievement'}
            </p>
            <h3 className="text-white font-bold montserrat text-4xl md:text-5xl leading-tight mt-5">
              25 {language === 'ru' ? 'ЭКСКЛЮЗИВНЫХ ОБРАЗОВ' : 'EXCLUSIVE LOOKS'}
            </h3>
            <p className="text-[#CEA15F] font-bold montserrat text-3xl md:text-4xl mt-3">
              30 {language === 'ru' ? 'ДНЕЙ' : 'DAYS'}
            </p>
            <p className="text-white/80 montserrat text-xs md:text-sm leading-relaxed mt-7 max-w-md">
              {language === 'ru'
                ? 'Создано с поистине космической скоростью — для показа в Каннах, Франция.'
                : 'Created at truly cosmic speed — for presentation in Cannes, France.'}
            </p>
          </div>
          <div>
            <MediaWithShimmer
              src="/pdf/aliens/achievement.jpg"
              alt="Exclusive look"
              className="w-full h-[320px] md:h-[540px] lg:h-[620px] object-cover"
            />
          </div>
        </div>

        {/* ── P7 CANNES RUNWAY — white page, trio of portraits ── */}
        <div className="bg-[#F9F8F4] px-6 md:px-12 lg:px-16 py-14 md:py-20">
          <p className="text-[#CEA15F] font-bold tracking-[0.3em] text-[11px] md:text-xs uppercase montserrat">
            {language === 'ru' ? 'Показ в Каннах' : 'Cannes Runway'}
          </p>
          <h3 className="text-gray-900 font-bold montserrat text-3xl md:text-4xl leading-tight mt-4">
            {language === 'ru' ? 'ИНОПЛАНЕТЯНЕ ВЫХОДЯТ НА ПОДИУМ' : 'ALIENS TAKE THE RUNWAY'}
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6 mt-8">
            {['/assets/WhatsApp%20Image%202026-09-01%20at%2013.31.18.jpeg', '/pdf/aliens/runway-2.jpg', '/pdf/aliens/runway-3.jpg'].map((src, index) => (
              <MediaWithShimmer
                key={index}
                src={src}
                alt={`ALIENS runway look ${index + 1}`}
                className="w-full aspect-[2/3] object-cover"
              />
            ))}
          </div>
        </div>

      </section>

      {/* ═══════════════════════════════════════════════════════════════
          JEWELLERY COLLECTION — PDF-style side-by-side layout
          ═══════════════════════════════════════════════════════════════ */}
            <section id="angelina-alriche-collection" className="bg-[#0C0C0F]">
        {/* ── P1 COVER — black panel LEFT (serif gold signature + bottom strip) / white photo RIGHT ── */}
        <div className="grid md:grid-cols-[54%_46%]">
          <div className="flex flex-col bg-[#0C0C0F]">
            <div className="px-6 md:px-12 lg:px-16 pt-14 md:pt-24 pb-10 flex-1 flex flex-col justify-center">
              <h2 className="playfair font-bold text-4xl md:text-5xl lg:text-6xl leading-[1.08]">
                <span className="text-white">ANGELINA</span><br />
                <span className="text-[#CEA15F]">ALRICHE</span>
              </h2>
              <div className="w-full max-w-md h-px bg-[#CEA15F]/70 my-7" />
              <p className="text-white font-bold montserrat tracking-[0.18em] text-lg md:text-2xl">
                {language === 'ru' ? 'ЮВЕЛИРНАЯ КОЛЛЕКЦИЯ' : 'JEWELLERY COLLECTION'}
              </p>
              <p className="playfair italic text-gray-300 text-sm md:text-base mt-6 max-w-md leading-relaxed">
                {language === 'ru'
                  ? 'Ювелирная вселенная дизайнера, где драгоценные материалы, скульптурная форма и инновации встречаются.'
                  : 'A designer jewellery universe where precious materials, sculptural form and innovation meet.'}
              </p>
            </div>
            <div className="bg-[#16161A] px-6 md:px-12 lg:px-16 py-6">
              <p className="text-[#CEA15F] font-bold montserrat text-sm">Since 1999</p>
              <p className="text-gray-300 montserrat text-xs md:text-sm mt-2">
                {language === 'ru'
                  ? 'Кольца • Обручальные кольца • Ювелирная haute couture'
                  : 'Rings • Wedding Rings • Couture Jewellery'}
              </p>
              <p className="text-gray-500 montserrat text-[10px] mt-3">
                {language === 'ru'
                  ? 'Подготовлено по материалам, предоставленным Angelina Alriche'
                  : 'Prepared from materials supplied by Angelina Alriche'}
              </p>
            </div>
          </div>
          <div className="bg-white order-first md:order-last">
            <MediaWithShimmer
              src="/pdf/jewellery/cover-flower.jpg"
              alt="Emerald Rose couture ring"
              eager={true}
              className="w-full h-[380px] md:h-full md:min-h-[620px] object-cover"
            />
          </div>
        </div>

        {/* ── 01 THE DESIGNER — black page, text LEFT / white card RIGHT ── */}
        <div className="px-6 md:px-12 lg:px-16 py-14 md:py-20 grid lg:grid-cols-2 gap-10 lg:gap-16">
          <div>
            <p className="text-[#CEA15F] font-bold tracking-[0.3em] text-[11px] md:text-xs uppercase montserrat">
              01 / {language === 'ru' ? 'Дизайнер' : 'The Designer'}
            </p>
            <h3 className="playfair font-bold text-white text-3xl md:text-4xl mt-4">Angelina Alriche</h3>
            <p className="text-[#CEA15F] montserrat text-[11px] md:text-xs tracking-[0.14em] uppercase mt-3">
              {language === 'ru'
                ? 'Международный дизайнер • Создатель ювелирных изделий • Новатор'
                : 'International designer • jewellery creator • innovator'}
            </p>
            <h4 className="text-white font-bold montserrat text-base md:text-lg mt-8">
              {language === 'ru' ? 'Творческий путь' : 'A creative career'}
            </h4>
            <p className="text-gray-300 montserrat text-sm md:text-[15px] leading-relaxed mt-4">
              {language === 'ru'
                ? 'Анжелина Алричи представлена брендом ALRICHE как международный дизайнер, чья творческая деятельность охватывает ювелирное искусство, моду, архитектуру и инновации в дизайне.'
                : 'Angelina Alriche is presented by the ALRICHE brand as an international designer whose creative work spans jewellery, fashion, architecture and design innovation.'}
            </p>
            <p className="text-gray-400 montserrat text-sm md:text-[15px] leading-relaxed mt-4">
              {language === 'ru'
                ? 'Её ювелирная практика построена вокруг оригинальных силуэтов, драгоценных материалов, эмали, драгоценных камней и экспериментальных технологий. Официальный сайт ALRICHE описывает ювелирную коллекцию, созданную в период 1998–2018 годов и продолжающуюся как активное направление дизайна.'
                : 'Her jewellery practice is built around distinctive silhouettes, precious materials, enamel, gemstones and experimental technologies. The official ALRICHE website describes a jewellery collection developed across the period 1998–2018 and continuing as an active design direction.'}
            </p>
          </div>
          <div className="flex flex-col items-center justify-center">
            <div className="bg-white w-full max-w-md p-3">
              <MediaWithShimmer
                src="/pdf/jewellery/designer-card.jpg"
                alt="Emerald Rose"
                className="w-full h-auto object-cover"
              />
              <p className="text-center text-[#CEA15F] montserrat font-bold text-xs tracking-[0.18em] mt-3">EMERALD ROSE</p>
              <p className="text-center text-gray-500 montserrat text-[11px] mt-1">
                {language === 'ru' ? 'Украшение как носимая скульптура' : 'Jewellery as wearable sculpture'}
              </p>
            </div>
          </div>
        </div>

        {/* ── 02 INNOVATION — black page, white card LEFT / idea+specs RIGHT ── */}
        <div className="px-6 md:px-12 lg:px-16 py-14 md:py-20">
          <p className="text-[#CEA15F] font-bold tracking-[0.3em] text-[11px] md:text-xs uppercase montserrat">
            02 / {language === 'ru' ? 'Инновации' : 'Innovation'}
          </p>
          <h3 className="playfair font-bold text-white text-3xl md:text-4xl mt-4">
            {language === 'ru' ? 'Ювелирные изделия, меняющие правила' : 'Jewellery that changes the rules'}
          </h3>
          <p className="text-gray-400 montserrat text-xs md:text-sm mt-3 max-w-xl">
            {language === 'ru'
              ? 'Материалы, вдохновлённые нанотехнологиями, и цвет как часть языка дизайна'
              : 'Nanotechnology-inspired materials and color as part of the design language'}
          </p>
          <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 mt-10">
            <div className="flex flex-col items-center justify-center">
              <div className="bg-white w-full max-w-md p-3">
                <MediaWithShimmer
                  src="/pdf/jewellery/innovation-card.jpg"
                  alt="Emerald Rose nanotechnology glass"
                  className="w-full h-auto object-cover"
                />
                <p className="text-center text-[#CEA15F] montserrat font-bold text-xs tracking-[0.18em] mt-3">EMERALD ROSE</p>
              </div>
            </div>
            <div>
              <h4 className="text-[#CEA15F] font-bold montserrat tracking-[0.14em] text-sm md:text-base">
                {language === 'ru' ? 'КОНЦЕПЦИЯ ALRICHE' : 'THE ALRICHE IDEA'}
              </h4>
              <p className="text-gray-300 montserrat text-sm md:text-[15px] leading-relaxed mt-4">
                {language === 'ru'
                  ? 'Некоторые ювелирные изделия ALRICHE изготовлены из специального стекла нанотехнологий и других инновационных материалов. Бренд представляет эти изделия как способные создавать необычные визуальные эффекты, включая смену цвета.'
                  : 'Some ALRICHE jewellery designs are described as using specialized nanotechnology glass and other innovative materials. The brand presents these pieces as capable of creating unusual visual effects, including color change.'}
              </p>
              <div className="space-y-5 mt-8">
                <div className="flex items-start gap-4">
                  <span className="w-3.5 h-3.5 rounded-full mt-1 flex-shrink-0" style={{ backgroundColor: '#8A232C' }} />
                  <div>
                    <h5 className="text-white font-bold montserrat text-xs tracking-[0.18em] uppercase">
                      {language === 'ru' ? 'Материал' : 'Material'}
                    </h5>
                    <p className="text-gray-400 montserrat text-sm mt-1">
                      {language === 'ru' ? 'Специальное стекло и эмаль' : 'Specialized glass and enamel'}
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <span className="w-3.5 h-3.5 rounded-full mt-1 flex-shrink-0" style={{ backgroundColor: '#3A6089' }} />
                  <div>
                    <h5 className="text-white font-bold montserrat text-xs tracking-[0.18em] uppercase">
                      {language === 'ru' ? 'Цвет' : 'Color'}
                    </h5>
                    <p className="text-gray-400 montserrat text-sm mt-1">
                      {language === 'ru' ? 'Призван менять визуальный характер' : 'Designed to shift visual character'}
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <span className="w-3.5 h-3.5 rounded-full mt-1 flex-shrink-0" style={{ backgroundColor: '#BF9D59' }} />
                  <div>
                    <h5 className="text-white font-bold montserrat text-xs tracking-[0.18em] uppercase">
                      {language === 'ru' ? 'Мастерство' : 'Craft'}
                    </h5>
                    <p className="text-gray-400 montserrat text-sm mt-1">
                      {language === 'ru' ? 'Ювелирные изделия ручной работы с драгоценными камнями' : 'Handmade jewellery with precious stones'}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ── 03 EVERYDAY & MID-RANGE — black page, two white cards ── */}
        <div className="px-6 md:px-12 lg:px-16 py-14 md:py-20">
          <p className="text-[#CEA15F] font-bold tracking-[0.3em] text-[11px] md:text-xs uppercase montserrat">
            03 / {language === 'ru' ? 'На каждый день' : 'Everyday & Mid-Range'}
          </p>
          <h3 className="playfair font-bold text-white text-3xl md:text-4xl mt-4">
            {language === 'ru' ? 'Ювелирные изделия на каждый день' : 'Jewellery for every day'}
          </h3>
          <p className="text-gray-400 montserrat text-xs md:text-sm mt-3 max-w-xl">
            {language === 'ru'
              ? 'Более доступное выражение языка дизайна ALRICHE'
              : 'A more accessible expression of the ALRICHE design language'}
          </p>
          <div className="grid sm:grid-cols-2 gap-6 md:gap-8 mt-10 max-w-5xl mx-auto">
            <div>
              <div className="bg-white p-3">
                <div className="flex items-start justify-between mb-3">
                  <h4 className="text-gray-900 font-bold montserrat text-sm md:text-base">
                    {language === 'ru' ? 'Обручальные кольца' : 'Wedding rings'}
                  </h4>
                  <span className="text-[#CEA15F] montserrat font-bold text-xs">01</span>
                </div>
                <Link to="/shop" className="block">
                  <MediaWithShimmer
                    src="/pdf/jewellery/everyday-1.jpg"
                    alt="Everyday rings"
                    className="w-full h-[240px] md:h-[300px] object-cover"
                  />
                </Link>
              </div>
              <p className="text-[#CEA15F] montserrat font-bold text-[11px] tracking-[0.18em] uppercase mt-3">
                {language === 'ru' ? 'Повседневные кольца' : 'Everyday Rings'}
              </p>
            </div>
            <div>
              <div className="bg-white p-3">
                <div className="flex items-start justify-between mb-3">
                  <h4 className="text-gray-900 font-bold montserrat text-sm md:text-base">
                    {language === 'ru' ? 'Кольцо «Мир»' : 'World ring'}
                  </h4>
                  <span className="text-[#CEA15F] montserrat font-bold text-xs">02</span>
                </div>
                <Link to="/shop" className="block">
                  <MediaWithShimmer
                    src="/pdf/jewellery/everyday-2.jpg"
                    alt="World ring signature piece"
                    className="w-full h-[240px] md:h-[300px] object-cover"
                  />
                </Link>
              </div>
              <p className="text-[#CEA15F] montserrat font-bold text-[11px] tracking-[0.18em] uppercase mt-3">
                {language === 'ru' ? 'Фирменные изделия' : 'Signature Pieces'}
              </p>
            </div>
          </div>
        </div>

        {/* ── 04 LUXURY COLLECTION — black page, five signature worlds (2x2 + 1) ── */}
        <div className="px-6 md:px-12 lg:px-16 py-14 md:py-20">
          <p className="text-[#CEA15F] font-bold tracking-[0.3em] text-[11px] md:text-xs uppercase montserrat">
            04 / {language === 'ru' ? 'Люкс-коллекция' : 'Luxury Collection'}
          </p>
          <h3 className="playfair font-bold text-white text-3xl md:text-4xl mt-4">
            {language === 'ru' ? 'Пять фирменных миров' : 'Five signature worlds'}
          </h3>
          <p className="text-gray-400 montserrat text-xs md:text-sm mt-3 max-w-xl">
            {language === 'ru'
              ? 'Тщательно подобранная подборка концепций коллекции, предоставленных для этой презентации'
              : 'A curated selection of the collection concepts supplied for this presentation'}
          </p>
          <div className="grid md:grid-cols-2 gap-5 md:gap-6 mt-10">
            {[
              { num: '01', dot: '#8A232C', name: 'RED FLOWER', desc: language === 'ru' ? 'Рубиновая эмаль, бриллианты и золото' : 'Ruby red enamel, diamonds and gold' },
              { num: '02', dot: '#3C7E60', name: 'GREEN FLOWER', desc: language === 'ru' ? 'Изумруды, бриллианты и стекло нанотехнологий' : 'Emeralds, diamonds and nanotechnology glass' },
              { num: '03', dot: '#3A6089', name: 'BLUE STONE', desc: language === 'ru' ? 'Синий драгоценный камень в океанском стиле' : 'Ocean-inspired blue gemstone expression' },
              { num: '04', dot: '#BF9D59', name: 'THE WORLD ON RING', desc: language === 'ru' ? 'Скульптурное кольцо с вселенским характером' : 'A sculptural ring concept with a universe-like character' },
              { num: '05', dot: '#C9CBD1', name: language === 'ru' ? 'СИНИЙ КАМЕНЬ НА ШЕЕ' : 'BLUE STONE ON THE NECK', desc: language === 'ru' ? 'Колье-высказывание, построенное вокруг цвета и формы' : 'A statement necklace built around color and form', wide: true }
            ].map((item, index) => (
              <div
                key={index}
                className={`bg-[#131317] rounded-lg px-6 py-6 flex items-center gap-5 ${item.wide ? 'md:col-span-2 md:max-w-xl md:mx-auto w-full' : ''}`}
              >
                <span className="w-4 h-4 rounded-full flex-shrink-0" style={{ backgroundColor: item.dot }} />
                <span className="text-[#CEA15F] montserrat font-bold text-xs flex-shrink-0">{item.num}</span>
                <div>
                  <h4 className="text-white font-bold montserrat text-sm md:text-base tracking-[0.06em]">{item.name}</h4>
                  <p className="text-gray-400 montserrat text-xs mt-1.5">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ── 05 COUTURE FLOWERS — black page, two white cards with colored captions ── */}
        <div className="px-6 md:px-12 lg:px-16 py-14 md:py-20">
          <p className="text-[#CEA15F] font-bold tracking-[0.3em] text-[11px] md:text-xs uppercase montserrat">
            05 / {language === 'ru' ? 'Кутюрные цветы' : 'Couture Flowers'}
          </p>
          <h3 className="playfair font-bold text-white text-3xl md:text-4xl mt-4">
            {language === 'ru' ? 'Красная Роза и Зелёное золото' : 'Red Rose & Green gold'}
          </h3>
          <p className="text-gray-400 montserrat text-xs md:text-sm mt-3 max-w-xl">
            {language === 'ru'
              ? 'Два флоральных высказывания — одно огненное, другое ботаническое'
              : 'Two floral statements — one fiery, one botanical'}
          </p>
          <div className="grid sm:grid-cols-2 gap-6 md:gap-8 mt-10 max-w-5xl mx-auto">
            <div>
              <div className="bg-white p-3">
                <Link to="/shop" className="block">
                  <MediaWithShimmer
                    src="/pdf/jewellery/flowers-1.jpg"
                    alt="Red Rose ring"
                    className="w-full h-[260px] md:h-[320px] object-cover"
                  />
                </Link>
              </div>
              <h4 className="text-[#C2453A] font-bold montserrat text-sm tracking-[0.14em] mt-4">RED ROSE</h4>
              <p className="text-gray-400 montserrat text-xs mt-1.5">
                {language === 'ru' ? 'Рубин • бриллианты • красная эмаль • золото 18К' : 'Ruby • diamond • red enamel • 18K gold'}
              </p>
              <ExpandableDescription
                language={language}
                title={language === 'ru' ? '"Красная Роза"' : '"Red Rose"'}
                fullText={language === 'ru'
                  ? 'Кольцо авторской ручной работы.\nБриллианты 3 карата\nРубины 0,9 карат\nЗолото 750°\nЭмаль красная'
                  : 'Handcrafted ring.\nDiamonds 3 carats\nRubies 0.9 carats\n18k Gold\nRed enamel'}
              />
            </div>
            <div>
              <div className="bg-white p-3">
                <Link to="/shop" className="block">
                  <MediaWithShimmer
                    src="/pdf/jewellery/flowers-2.jpg"
                    alt="Emerald Rose ring"
                    className="w-full h-[260px] md:h-[320px] object-cover"
                  />
                </Link>
              </div>
              <h4 className="text-[#5FA57F] font-bold montserrat text-sm tracking-[0.14em] mt-4">EMERALD ROSE</h4>
              <p className="text-gray-400 montserrat text-xs mt-1.5">
                {language === 'ru' ? 'Изумруд • бриллианты • стекло нанотехнологий • золото 18К' : 'Emerald • diamond • nanotechnology glass • 18K gold'}
              </p>
              <ExpandableDescription
                language={language}
                title={language === 'ru' ? '"Зелёная Роза"' : '"Emerald Rose"'}
                fullText={language === 'ru'
                  ? 'Представленная в неполном формате ювелирная коллекция созданная с 1998 и 2018 годы. В коллекцию входит стекло нанотехнологии, золото 18 карат (750°) цветная эмаль, бриллианты VVS1, VVS2 изумруды, рубины, и аметисты.'
                  : 'Presented in an incomplete format, this jewelry collection was created between 1998 and 2018. The collection includes nanotechnology-glass, 18-karat gold (750°), colored enamel, VVS 1, VVS2, diamonds, emeralds, rubies, and amethysts.'}
              />
            </div>
          </div>
        </div>

        {/* ── 06 UNIVERSE — black page, two white cards with colored captions ── */}
        <div className="px-6 md:px-12 lg:px-16 py-14 md:py-20">
          <p className="text-[#CEA15F] font-bold tracking-[0.3em] text-[11px] md:text-xs uppercase montserrat">
            06 / {language === 'ru' ? 'Вселенная' : 'Universe'}
          </p>
          <h3 className="playfair font-bold text-white text-3xl md:text-4xl mt-4">
            {language === 'ru' ? 'Синий камень и белые бриллианты' : 'Blue stone & White brilliants'}
          </h3>
          <p className="text-gray-400 montserrat text-xs md:text-sm mt-3 max-w-xl">
            {language === 'ru'
              ? 'Космическое настроение, выраженное через геометрию, цвет и сверкающие камни'
              : 'A cosmic mood expressed through geometry, color and brilliant stones'}
          </p>
          <div className="grid sm:grid-cols-2 gap-6 md:gap-8 mt-10 max-w-5xl mx-auto">
            <div>
              <div className="bg-white p-3">
                <Link to="/shop" className="block">
                  <MediaWithShimmer
                    src="/pdf/jewellery/universe-1.jpg"
                    alt="Blue Stone ring"
                    className="w-full h-[260px] md:h-[320px] object-cover"
                  />
                </Link>
              </div>
              <h4 className="text-[#7FA8C9] font-bold montserrat text-sm tracking-[0.14em] mt-4">BLUE STONE</h4>
              <p className="text-gray-400 montserrat text-xs mt-1.5">
                {language === 'ru' ? 'Синий камень • бриллианты • золото' : 'Blue stone • diamonds • gold'}
              </p>
              <ExpandableDescription
                language={language}
                title={language === 'ru' ? 'Галактика' : 'GALAXY'}
                fullText={language === 'ru'
                  ? 'Кольцо — ручной работы, в единственном экземпляре.\nСиняя эмаль\n18-каратное золото (750°)\nБриллианты чистотой VVS1\nОбщий вес: 4,5 карата'
                  : 'The ring is a one-of-a-kind, handmade piece.\nBlue enamel\n18K gold (750°)\nVVS1 diamonds\nTotal weight: 4.5 carats'}
              />
            </div>
            <div>
              <div className="bg-white p-3">
                <Link to="/shop" className="block">
                  <MediaWithShimmer
                    src="/pdf/jewellery/universe-2.jpg"
                    alt="The World on Ring"
                    className="w-full h-[260px] md:h-[320px] object-cover"
                  />
                </Link>
              </div>
              <h4 className="text-[#BF9D59] font-bold montserrat text-sm tracking-[0.14em] mt-4">THE WORLD ON RING</h4>
              <p className="text-gray-400 montserrat text-xs mt-1.5">
                {language === 'ru' ? 'Бриллианты • скульптурная оправа • золото' : 'Diamonds • sculptural setting • gold'}
              </p>
            </div>
          </div>
        </div>

        {/* ── 07 STATEMENT JEWELLERY — black page, two white cards with gold captions ── */}
        <div className="px-6 md:px-12 lg:px-16 py-14 md:py-20">
          <p className="text-[#CEA15F] font-bold tracking-[0.3em] text-[11px] md:text-xs uppercase montserrat">
            07 / {language === 'ru' ? 'Грандиозные украшения' : 'Statement Jewellery'}
          </p>
          <h3 className="playfair font-bold text-white text-3xl md:text-4xl mt-4">
            {language === 'ru' ? 'Украшения с присутствием' : 'Jewellery with presence'}
          </h3>
          <p className="text-gray-400 montserrat text-xs md:text-sm mt-3 max-w-xl">
            {language === 'ru'
              ? 'От выразительного кулона до символа изобилия'
              : 'From an expressive pendant to a symbol of abundance'}
          </p>
          <div className="grid sm:grid-cols-2 gap-6 md:gap-8 mt-10 max-w-5xl mx-auto">
            <div>
              <div className="bg-white p-3">
                <Link to="/shop" className="block">
                  <MediaWithShimmer
                    src="/pdf/jewellery/statement-1.jpg"
                    alt="Wealth pendant"
                    className="w-full h-[260px] md:h-[320px] object-cover"
                  />
                </Link>
              </div>
              <h4 className="text-[#CEA15F] font-bold montserrat text-sm tracking-[0.14em] mt-4">WEALTH</h4>
              <p className="text-gray-400 montserrat text-xs mt-1.5">
                {language === 'ru'
                  ? 'Бриллианты • бирюза • изумруды • сапфиры • эмаль • золото'
                  : 'Diamonds • turquoise • emeralds • sapphires • enamel • gold'}
              </p>
            </div>
            <div>
              <div className="bg-white p-3">
                <Link to="/shop" className="block">
                  <MediaWithShimmer
                    src="/pdf/jewellery/statement-2.jpg"
                    alt="Infinite Wealth earrings"
                    className="w-full h-[260px] md:h-[320px] object-cover"
                  />
                </Link>
              </div>
              <h4 className="text-[#CEA15F] font-bold montserrat text-sm tracking-[0.14em] mt-4">INFINITE WEALTH</h4>
              <p className="text-gray-400 montserrat text-xs mt-1.5">
                {language === 'ru'
                  ? 'Бриллианты • белое/жёлтое/коричневое золото'
                  : 'Diamonds • white/yellow/brown gold'}
              </p>
            </div>
          </div>
        </div>

        {/* ── 08 COLLECTION STATEMENT — black page, three gold-ruled columns ── */}
        <div className="px-6 md:px-12 lg:px-16 py-14 md:py-20">
          <p className="text-[#CEA15F] font-bold tracking-[0.3em] text-[11px] md:text-xs uppercase montserrat">
            08 / {language === 'ru' ? 'Философия коллекции' : 'Collection Statement'}
          </p>
          <h3 className="playfair font-bold text-white text-3xl md:text-4xl mt-4">
            {language === 'ru' ? 'Видение ювелирной коллекции ALRICHE' : 'The ALRICHE jewellery vision'}
          </h3>
          <p className="playfair italic text-gray-300 text-sm md:text-base mt-5 max-w-2xl leading-relaxed">
            {language === 'ru'
              ? 'Роскошь — это не только стоимость камня. Это идея, конструкция, эмоция и история, которую несёт изделие.'
              : 'Luxury is not only the value of the stone. It is the idea, the construction, the emotion and the story carried by the piece.'}
          </p>
          <div className="grid sm:grid-cols-3 gap-8 mt-10">
            {[
              { title: language === 'ru' ? 'Красота' : 'Beauty', text: language === 'ru' ? 'Флоральные формы, драгоценные камни и эмаль создают сильный визуальный почерк.' : 'Floral forms, gemstones and enamel create a strong visual signature.' },
              { title: language === 'ru' ? 'Инновации' : 'Innovation', text: language === 'ru' ? 'Экспериментальные материалы и технологии используются как часть концепции дизайна.' : 'Experimental materials and technology are used as part of the design concept.' },
              { title: language === 'ru' ? 'Индивидуальность' : 'Identity', text: language === 'ru' ? 'Каждое изделие задумано как узнаваемый объект личного выражения.' : 'Each piece is conceived as a recognizable object of personal expression.' }
            ].map((item, index) => (
              <div key={index}>
                <div className="w-full h-px bg-[#CEA15F]/60 mb-4" />
                <h4 className="text-white font-bold montserrat text-xs tracking-[0.18em] uppercase">{item.title}</h4>
                <p className="text-gray-400 montserrat text-xs md:text-sm leading-relaxed mt-3">{item.text}</p>
              </div>
            ))}
          </div>
          <div className="mt-12">
            <h4 className="text-white font-bold montserrat text-base">Angelina Alriche</h4>
            <p className="text-gray-500 montserrat text-xs mt-1.5">
              {language === 'ru'
                ? 'международный дизайнер • создатель ювелирных изделий'
                : 'International designer • jewellery creator'}
            </p>
          </div>
        </div>

        {/* ── P10 FINALE — black page, serif signature + quote LEFT / two cards RIGHT ── */}
        <div className="px-6 md:px-12 lg:px-16 py-14 md:py-20 grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div>
            <h3 className="playfair font-bold text-4xl md:text-5xl leading-[1.08]">
              <span className="text-white">ANGELINA</span><br />
              <span className="text-[#CEA15F]">ALRICHE</span>
            </h3>
            <p className="text-white font-bold montserrat tracking-[0.18em] text-sm md:text-lg mt-6">
              {language === 'ru' ? 'ЮВЕЛИРНАЯ КОЛЛЕКЦИЯ' : 'JEWELLERY COLLECTION'}
            </p>
            <div className="w-full max-w-md h-px bg-[#CEA15F]/70 my-8" />
            <p className="playfair italic text-gray-300 text-sm md:text-base">
              {language === 'ru' ? 'С наилучшими пожеланиями, Angelina Alriche' : 'With big regards, Angelina Alriche'}
            </p>
            <p className="playfair italic text-[#D8C08A] text-2xl md:text-3xl leading-snug mt-8">
              &ldquo;If you buy Alriche<br />You will be riche&rdquo;
            </p>
            <p className="text-gray-500 montserrat text-[10px] mt-10">
              {language === 'ru'
                ? 'Для презентационных и бренд-профильных целей'
                : 'For presentation and brand-profile use'}
            </p>
          </div>
          <div className="flex items-center justify-center lg:justify-end gap-4">
            <div className="bg-white p-2 w-36 md:w-48">
              <MediaWithShimmer
                src="/pdf/jewellery/finale-1.jpg"
                alt="ALRICHE jewellery piece"
                className="w-full h-auto object-cover"
              />
            </div>
            <div className="bg-white p-2 w-36 md:w-48">
              <MediaWithShimmer
                src="/pdf/jewellery/finale-2.jpg"
                alt="ALRICHE jewellery piece"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
export default AlrichePresentation
